import React from "react";
import HeaderLesson from "./HeaderLesson";
import FooterLesson from "./FooterLesson";

/**
 * Full-page layout that shows a single centered message
 * (loading, error, empty, unsupported, ...).
 * Header and footer can be overridden per use case.
 */
const ContentMessage = ({
                            message,
                            header = <HeaderLesson/>,
                            footer = <FooterLesson/>,
                        }) => (
    <div className="min-h-screen flex flex-col">
        {header}

        <main className="flex-1 flex items-center justify-center">
            <p>{message}</p>
        </main>

        {footer}
    </div>
);

export default ContentMessage;